import { dateFilter, currencyFilter } from '@/utils/filters';
import ContentBox from '@/components/supplier/dashboard/content-box';
import { HalfCircleSpinner } from 'epic-spinners';

export default {
    name: 'PlanOverview',
    components: {
        ContentBox,
        HalfCircleSpinner
    },
    props: {
        subscription: Object,
        loader: Boolean
    },
    data: () => ({}),
    async created() {},
    methods: {
        dateFilter,
        currencyFilter
    }
};
